import React from 'react';
import propTypes from 'prop-types';

export const CheckSquareIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      fill={color}
      width={sizeInPixel}
      height={sizeInPixel}
      className={variant}
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 489.8 489.8"
      xmlSpace="preserve"
    >
      <g>
        <g>
          <path
            d="M438.2,0H51.6C23.1,0,0,23.2,0,51.6v386.6c0,28.5,23.2,51.6,51.6,51.6h386.6c28.5,0,51.6-23.2,51.6-51.6V51.6
			C489.8,23.2,466.6,0,438.2,0z M465.3,438.2c0,14.9-12.2,27.1-27.1,27.1H51.6c-14.9,0-27.1-12.2-27.1-27.1V51.6
			c0-14.9,12.2-27.1,27.1-27.1h386.6c14.9,0,27.1,12.2,27.1,27.1V438.2z"
          />
          <path
            d="M319.5,177.9l-108.7,108l-40.5-40.7c-4.8-4.8-12.5-4.8-17.3,0c-4.8,4.8-4.8,12.5,0,17.3l49.1,49.4
			c2.3,2.3,5.4,3.6,8.7,3.6l0,0c3.2,0,6.3-1.3,8.6-3.6l117.4-116.7c4.8-4.8,4.8-12.5,0-17.3C332,173.1,324.3,173.1,319.5,177.9z"
          />
        </g>
      </g>
    </svg>
  );
};
CheckSquareIcon.propTypes = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
CheckSquareIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
